export const fastaSize = 1*1000*1000
export const sampleSize = 500
export const groupSize = 500
export const envSize = 500
export const treeSize = 500
export const picrustSize = 500
export const zipSize = 10000
